import './header.css'
import React from 'react'

export const Header = () => {
  return (
    <div id='home' className='container header-container'>
      <h3><p>I<span>'</span>m</p>Juan Florez</h3>
      <h2>Full Stack Web Developer</h2>
    </div>
  )
}